import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class WakeLockService {
  private wakeLock: WakeLockSentinel | null = null;

  async enable() {
    try {
      if ('wakeLock' in navigator) {
        this.wakeLock = await (navigator as any).wakeLock.request('screen');
        console.log('Wake Lock activated.');

        // Re-acquire if released due to tab change
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
      }
    } catch (err) {
      console.error('Wake Lock error:', err);
    }
  }

  async disable() {
    try {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      if (this.wakeLock) {
        await this.wakeLock.release();
        this.wakeLock = null;
        console.log('Wake Lock released.');
      }
    } catch (err) {
      console.error('Failed to release Wake Lock:', err);
    }
  }

  private handleVisibilityChange = async () => {
    if (document.visibilityState === 'visible' && this.wakeLock === null) {
      await this.enable();
    }
  };
}
